import { useRef, useState } from 'react'
import type { ReactNode } from 'react'
import { EllipsisHorizontalIcon } from '@heroicons/react/16/solid'
import { useDismissable } from '../../../Framework/View/Hooks/useDismissable.ts'

export const OverflowMenu = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false)
  const root = useRef<HTMLDivElement>(null)
  useDismissable(root, open, () => setOpen(false))
  return (
    <div ref={root} className="relative shrink-0">
      <button
        type="button"
        className="btn btn-ghost btn-sm btn-square"
        aria-label="More actions"
        aria-haspopup="menu"
        aria-expanded={open}
        data-testid="wizard-overflow"
        onClick={() => setOpen((current) => !current)}
      >
        <EllipsisHorizontalIcon className="h-5 w-5" />
      </button>
      {open && (
        <ul
          role="menu"
          className="menu absolute right-0 z-30 mt-1 w-72 rounded-box border border-slate-200 bg-white p-1 text-sm shadow-lg"
          data-testid="wizard-overflow-menu"
          onClick={() => setOpen(false)}
        >
          {children}
        </ul>
      )}
    </div>
  )
}
